import { styled } from "@mui/material";
import Button from "@mui/material/Button";

export const InternalLinkBaseButton = styled(Button)(() => ({
	fontSize: "1.6rem",
}));

export const AppBarLinkButton = styled(InternalLinkBaseButton)(({ theme }) => ({
	marginBottom: 0,
	border: "none",
	padding: "5px 8px",
	fontWeight: 400,
	color: theme.palette.grey[800],
	backgroundColor: "transparent",
	fontFamily: "NNNittiGroteskTextRegular",
	"&:hover": {
		background: "none",

	},
	"& .MuiButton-startIcon": {
		marginLeft: 0,
		marginRight: theme.spacing(4),
	},
}));